import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const getAIMessages = (intl) => [
  intl.formatMessage({ defaultMessage: 'Working some photo magic...' }),
  intl.formatMessage({ defaultMessage: 'Creating transparency...' }),
  intl.formatMessage({ defaultMessage: 'Zapping backgrounds away...' }),
  intl.formatMessage({ defaultMessage: 'Unleashing the eraser...' }),
  intl.formatMessage({ defaultMessage: 'Making pixels disappear...' }),
  intl.formatMessage({ defaultMessage: 'Poof!' }),
  intl.formatMessage({ defaultMessage: 'Zap!' }),
  intl.formatMessage({ defaultMessage: 'Erasing...' }),
  intl.formatMessage({ defaultMessage: 'Removing...' }),
  intl.formatMessage({ defaultMessage: 'Cleaning...' }),
  intl.formatMessage({ defaultMessage: 'Working some AI magic...' }),
  intl.formatMessage({ defaultMessage: 'Analyzing your image...' }),
  intl.formatMessage({ defaultMessage: 'Thinking in pixels...' }),
  intl.formatMessage({ defaultMessage: 'Enhancing details...' }),
  intl.formatMessage({ defaultMessage: 'Reimagining your image...' }),
  intl.formatMessage({ defaultMessage: 'Applying intelligent edits...' }),
  intl.formatMessage({ defaultMessage: 'Optimizing visuals...' }),
  intl.formatMessage({ defaultMessage: 'Transforming your image...' }),
  intl.formatMessage({ defaultMessage: 'Refining the results...' }),
  intl.formatMessage({ defaultMessage: 'Almost there...' }),
  intl.formatMessage({ defaultMessage: 'Just a moment...' }),
  intl.formatMessage({ defaultMessage: 'Putting the final touches on it...' }),
  intl.formatMessage({ defaultMessage: 'Teaching pixels some new tricks...' }),
  intl.formatMessage({ defaultMessage: 'Convincing the background to take a vacation...' }),
  intl.formatMessage({ defaultMessage: 'Negotiating with stubborn edges...' }),
  intl.formatMessage({ defaultMessage: 'Sprinkling a little AI fairy dust...' }),
  intl.formatMessage({ defaultMessage: 'Polishing pixels one by one...' }),
  intl.formatMessage({ defaultMessage: 'Untangling tiny details...' }),
  intl.formatMessage({ defaultMessage: 'Warming up the neural noodles...' }),
  intl.formatMessage({ defaultMessage: 'Doing some very serious pixel business...' }),
  intl.formatMessage({ defaultMessage: 'Bribing the background to disappear...' }),
  intl.formatMessage({ defaultMessage: 'Sharpening the digital scissors...' }),
  intl.formatMessage({ defaultMessage: 'Tidying up the visual crumbs...' }),
  intl.formatMessage({ defaultMessage: 'Massaging the metadata...' }),
  intl.formatMessage({ defaultMessage: 'Whispering sweet instructions to the AI...' }),
  intl.formatMessage({ defaultMessage: 'Aligning the pixels just right...' }),
  intl.formatMessage({ defaultMessage: 'Letting the AI stretch its legs...' }),
  intl.formatMessage({ defaultMessage: 'Untangling the visual spaghetti...' }),
  intl.formatMessage({ defaultMessage: 'Making tiny, invisible improvements...' }),
  intl.formatMessage({ defaultMessage: 'Double-checking every pixel...' }),
  intl.formatMessage({ defaultMessage: 'Cooking up something nice...' }),
  intl.formatMessage({ defaultMessage: 'Letting the magic simmer for a sec...' }),
  intl.formatMessage({ defaultMessage: 'Brewing your edit to perfection...' }),
  intl.formatMessage({ defaultMessage: 'Giving it one more thoughtful look...' }),
  intl.formatMessage({ defaultMessage: 'Fine-tuning the tiny stuff...' }),
  intl.formatMessage({ defaultMessage: 'Almost ready to show off...' }),
  intl.formatMessage({ defaultMessage: 'Hang tight — greatness takes a second...' }),
  intl.formatMessage({ defaultMessage: 'Good things are rendering...' }),
  intl.formatMessage({ defaultMessage: 'Putting the pixels in their proper places...' }),
  intl.formatMessage({ defaultMessage: 'Making sure everything looks just right...' }),
  intl.formatMessage({ defaultMessage: 'Applying the secret sauce...' }),
  intl.formatMessage({ defaultMessage: 'One last sprinkle of awesome...' }),
];

const ImageEditorSidebarAILoader = ({ show }) => {
  const intl = useIntl();
  const messages = getAIMessages(intl);

  const [index, setIndex] = useState(
    Math.floor(Math.random() * messages.length),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(Math.floor(Math.random() * messages.length));
    }, 3000);

    return () => clearInterval(interval);
  }, [messages.length]);

  if (!show) {
    return null;
  }

  return (
    <div className="image-editor-sidebar-wrapper-loader">
      <div className="image-editor-sidebar-wrapper-loader-icon">
        <i className="fal fa-sparkles fa-fw" />
      </div>

      <div className="image-editor-sidebar-wrapper-loader-message">
        {messages[index]}
      </div>
    </div>
  );
};

ImageEditorSidebarAILoader.propTypes = {
  show: PropTypes.bool.isRequired,
};

export default ImageEditorSidebarAILoader;
